import { Styles, generateClasses } from 'netline-ui';

export const productMenuClasses = generateClasses('ProductsMenu', ['root', 'menuItem', 'categoryTitle'] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`.${productMenuClasses.menuItem}`]: {
    textDecoration: 'none',
    color: palette.grey[900],
    display: 'block',
  },

  [`.${productMenuClasses.categoryTitle}`]: {
    fontWeight: 900,
    color: palette.grey[900],
    padding: spacing(1),
    fontSize: 18,
  },
});

export default styles;
